/**
 * Agent approval thresholds — Zod schemas (the tenant agent-T3 default policy).
 *
 * Mirrors the backend agentapprovalpolicy handler:
 *   GET/PUT /api/v1/tenants/{tenant_id}/agent-approval-policy
 *
 * The tenant default is a GENERIC, unit-agnostic consequence policy (a list of per-dimension
 * thresholds; money "usd" is one dimension among many). null = no tenant default (the per-agent
 * registry ceiling alone governs). It can only TIGHTEN an agent's certified ceiling at mint
 * (effective = per-dimension intersection), never raise it.
 */

import { consequencePolicySchema } from "@pureid/auth-core";
import { z } from "zod";

export const agentApprovalPolicySchema = z.object({
  // The tenant default policy, or null when no default is set.
  default_consequence_policy: consequencePolicySchema.nullable(),
  // True once the tenant has configured the policy — the opt-in signal. Until then,
  // every value-bearing agent action escalates to human approval (the safe default).
  configured: z.boolean(),
});
export type AgentApprovalPolicy = z.infer<typeof agentApprovalPolicySchema>;
